import { FC } from 'react';
import { Theme } from '@mui/material/styles';
import { Box, Menu, MenuProps, Slide, SlideProps } from '@mui/material';
import { clsx } from '../../../utils';
import { Colors } from '../../../constants';
import { useMediaQuery } from '@mui/system';
import { menuStyles } from './core-menu.styles';
import { Showable } from '../../utils';

export interface CoreMenuProps extends Omit<MenuProps, 'onClose'> {
	onClose(): void;
}

export const CoreMenu: FC<CoreMenuProps> = (props) => {
	const { children, sx, anchorEl, onClose, ...menuProps } = props;
	const isLessThanSm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

	return (
		<Menu
			{...menuProps}
			sx={clsx(menuStyles, sx)}
			anchorEl={!isLessThanSm ? anchorEl : undefined}
			onClose={onClose}
			TransitionComponent={isLessThanSm ? Slide : undefined}
			TransitionProps={isLessThanSm ? { direction: 'up' } as SlideProps : undefined}
			anchorReference={isLessThanSm ? "none" : "anchorEl"}
		>
			<Showable show={isLessThanSm}>
				<Box sx={{ width: '100%', py: '8px', display: 'flex', justifyContent: 'center' }} onClick={onClose}>
					<Box sx={{ height: '3px', width: '20px', borderRadius: '3px', backgroundColor: Colors.white }} />
				</Box>
			</Showable>
			{children}
		</Menu>
	);
};
